import isEmpty from "lodash/isEmpty";

import { useTranslation } from "components/i18n/source";
import {
  useAppContext,
  useBootstrap,
  useReferral,
} from "components/store/source";

export const useFlow = () => {
  const { t } = useTranslation();
  const referralData = useReferral();
  const { signUpPopupProps } = useAppContext();
  const {
    featureFlags: { memberPricing },
  } = useBootstrap();

  const defaultValues = {
    showOAuth: true,
    signUpSelectorTitle: t(`modals.accounts.signUp.selector.title`),
  };

  // Referral
  if (!isEmpty(referralData)) {
    return {
      ...defaultValues,
      showReferral: true,
      showOAuth: false,
      signUpSelectorTitle: t(`modals.accounts.signUp.selector.titleReferral`, {
        referrerName: referralData.name,
        creditAmount: referralData.referralCreditAmount,
      }),
      loginDefaultErrorMessage: t("modals.accounts.errors.emailTaken"),
    };
  }

  // Exit intent
  if (signUpPopupProps?.isExitIntentModal === true) {
    return {
      ...defaultValues,
      showExitIntent: true,
      signUpSelectorTitle: t(
        `modals.accounts.signUp.selector.titleExitIntent${
          memberPricing ? "Experiment" : ""
        }`,
      ),
    };
  }

  return defaultValues;
};

export function getErrorMessage(gqlError) {
  return (
    gqlError.graphQLErrors
      .map(({ extensions = { message: "" } }) => extensions.message)
      .join("\n") || ""
  );
}
